import { render, staticRenderFns } from "./EditToolTnm.vue?vue&type=template&id=2209a1d8&scoped=true"
import script from "./EditToolTnm.vue?vue&type=script&lang=ts"
export * from "./EditToolTnm.vue?vue&type=script&lang=ts"
import style0 from "./EditToolTnm.vue?vue&type=style&index=0&id=2209a1d8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2209a1d8",
  null
  
)

export default component.exports